import { FaSearch, FaUser, FaChevronDown } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.svg";
import { useContext, useState, useEffect } from "react";
import { CartContext } from "../context/CartContext";
import { AuthContext } from "../context/AuthContext";
import CategoryNavbar from "./CategoryNavbar";
import "./Navbar.css";

function Navbar({ onSearch }) {
  const navigate = useNavigate();
  const { cart } = useContext(CartContext);
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [guestName, setGuestName] = useState("");

  useEffect(() => {
    const updateName = () => {
      const savedName = localStorage.getItem("userName");
      setGuestName(savedName || "");
    };
    updateName();
    window.addEventListener("storage", updateName);
    return () => window.removeEventListener("storage", updateName);
  }, [user]);

  const cartCount = cart.reduce((total, item) => total + (item.qty || item.quantity || 0), 0);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) onSearch(query);
    navigate(`/shop?search=${query}`);
  };

  const handleSignOut = () => {
  // Sirf zaroori items clear karein taaki cart safe rahe (optional)
  localStorage.removeItem("token");
  localStorage.removeItem("userName");
  
  if (logout) logout(); // AuthContext ka logout call karein
  
  setOpen(false); // Dropdown band karein
  
  // Important: Navigate ke baad page ko refresh karne ki zaroorat pad sakti hai agar state sync nahi hai
  navigate("/");
  window.location.reload(); // Isse state poori tarah reset ho jayegi
};

  const displayName = user?.name || guestName || "Guest";

  return (
    <div className="navbar-container">
      <header className="header">
        <div className="header-main-row">
          <div className="navLeft">
            <Link to="/" className="logoLink">
              <img src={logo} alt="Logo" className="siteLogo" />
              <div className="logo-text">
                <div className="logoMain">
                  <span className="lace">LACE</span>
                  <span className="gota">GOTA</span>
                </div>
              </div>
            </Link>
          </div>

          <div className="navRight">
            {/* Account Section */}
            <div 
              className={`navItem accountBlock ${open ? 'active' : ''}`} 
              onClick={() => {
                if (!(user || guestName)) {
                  navigate("/account"); // Agar login nahi hai toh direct login page
                } else {
                  setOpen(!open); // Login hai toh dropdown toggle karein
                }
              }}
            >
              <FaUser className="navIcon" />
              <div className="accountText desktop-only">
                <span className="navSmall">Hello, {displayName}</span>
                <span className="navBold">
                  Account <FaChevronDown className="arrowIcon" />
                </span>
              </div>
              
              {/* Dropdown Popup */}
              {open && (user || guestName) && (
                <div className="accountPopup" onClick={(e) => e.stopPropagation()}>
                  <Link to="/profile" onClick={() => setOpen(false)}>My Profile</Link>
                  <Link to="/orders" onClick={() => setOpen(false)}>My Orders</Link>
                  <Link to="/addresses" onClick={() => setOpen(false)}>Addresses</Link>
                  <hr />
                  <button className="signOutBtn" onClick={handleSignOut}>
                    Sign Out
                  </button>
                </div>
              )}
            </div>

            <Link to="/cart" className="navItem cart">
              <span className="cartIcon">🛒</span>
              {cartCount > 0 && <span className="cartCount">{cartCount}</span>}
            </Link>
          </div>
        </div>

        <div className="header-search-row">
          <form className="searchBox" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Search for lace, gota, borders..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button type="submit" className="searchBtn">
              <FaSearch />
            </button>
          </form>
        </div>
      </header>
      <CategoryNavbar />
    </div>
  );
}

export default Navbar;